import request from '../../utils/request';

export async function getHealthWeightRequest(params) {
  return request({
    url: 'healthWeight/getDictData',
    method: 'get',
    headers: 'json',
    params,
  });
}
export async function updateHealthWeightRequest(params) {
  return request({
    url: 'healthWeight/updateDictData',
    method: 'post',
    headers: 'json',
    params,
  });
}
